// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__284Gj","primary":"Link_primary__19LJw","white":"Link_white__GS0QP","underlined":"Link_underlined__2q2NQ","hover":"Link_hover__b0w1_"};